<template>
    <b-col lg="2">
        <div class="form-item form-item-select" :class="{ 'field-error': errors.has('currency') && showErrors }">
            <input type="hidden"
                   id="payout_currency"
                   v-model="selectedId">
            <label for="payout_currency_label"
                   class="form-label">Account currency</label>
            <div class="select-outer">
                <input type="text"
                       id="payout_currency_label"
                       name="currency"
                       v-model="selectedValue"
                       @focus="openList = true"
                       @blur="openList = hoverList ? true : false"
                       v-validate
                       data-vv-rules="required"
                       data-vv-as="account currency"
                       :readonly="true"
                       :disabled="sending">
                <ul v-show="openList && !sending">
                    <li v-for="(option, index) in options"
                        :key="index"
                        @click="setItem(index, option), openList = false"
                        @mouseover="hoverList = true"
                        @mouseleave="hoverList = false">{{ option }}</li>
                </ul>
                <p class="field-error--description" v-show="errors.has('currency') && showErrors">{{ errors.first('currency') }}</p>
            </div>
        </div>
    </b-col>
</template>

<script>
    export default {
        inject: ['$validator'],
        props: ['sending', 'showErrors', 'setValue'],
        data () {
            return {
                options: {
                    // EUR: 'EUR',
                    // USD: 'USD',
                    GBP: 'GBP',
                },
                openList: false,
                hoverList: false,
                selectedId: 'GBP',
                selectedValue: 'GBP'
            }
        },
        methods: {
            setItem (id, value) {
                this.selectedValue = value
                this.selectedId = id
            }
        },
        mounted () {
            this.setValue('currency', this.selectedId);
        },
        watch: {
            selectedId () {
                this.setValue('currency', this.selectedId);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/payout/bankTransfer/AccountCurrency.vue